import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/nav";
import Footer from "./Components/Footer";
import Home from "./Pages/HomePage";
import Upload from "./Pages/UploadPage";
import U1 from "./Components/Getmydata";
import U2 from "./Components/Upload";
import Privacy from "./Pages/PrivacyPage";
import Terms from "./Pages/TermsPage";
import Contact from "./Pages/ContactPage";

function App() {
    return (
        <div className="App">
            <Router>
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/upload" element={<Upload />}>
                        <Route path="u1" element={<U1 />} />
                        <Route path="u2" element={<U2 />} />
                    </Route>
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<div>404 Not Found</div>} />
                </Routes>
                <Footer />
            </Router>
        </div>
    );
}

export default App;